import getCookieAttribution from './attribution/getCookieAttribution';
import getUrlAttribution from './attribution/getUrlAttribution';
import { getReferrer, getUrl } from './BrowserUtils';
export function getAttribution() {
  const urlAttribution = getUrlAttribution(getUrl());
  if (urlAttribution) return urlAttribution;
  const referrerAttribution = getUrlAttribution(getReferrer());
  if (referrerAttribution) return referrerAttribution;
  return getCookieAttribution();
}